<template>
  <div class="row">
    <div class="col-lg-2 col-md-3 private-project-border" style="max-height: 750px;overflow-y: scroll;">
      <div class="row mb-2 pb-3" style="border-bottom: 1px solid #f3f3f3" >
        <div class="input-group">
          <span class="input-group-text"><font-awesome-icon icon="filter"  style="color: #1e3e67"/></span>
          <input v-model="searchText" placeholder="Search Project" class="align-items-sm-center form-control" type="search">
        </div>
      </div>
      <div class="accordion" id="accordionExample">
        <div class="accordion-item" v-for="(userProject, index) in userProjects" :key="userProject.id"
             :style="{border: userProject.projectId == selectedProjectId ? '1px solid #56759c' : '',
                     background: userProject.projectId == selectedProjectId ? '#f2f6f9' : ''}">
          <h2 class="accordion-header" id="headingOne">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapseOne_' + index" aria-expanded="false"
                    @click="goToDetails(userProject.projectId,userProject.projectName,userProject.projectCode)">
              <span class="mx-2" style="font-size: 14px">{{userProject.projectName}}</span>
            </button>
          </h2>
          <div :id="'collapseOne_' + index" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <div class="accordion">
                <div class="groupName" :style="{textDecoration: 'all' == selectedGroupId ? 'underline' : '',
                                            textUnderlinePosition: 'all' == selectedGroupId ? 'under' : ''}" style="font-size: 12px">
                  <ul  @click="getFilter('all')">
                    <li class="mx-4">All</li>
                  </ul>
                </div>
                <div v-if="userProject.projectId == selectedProjectId && projectPermissions.length != 0">
                    <div v-for="permission in returnDistinctList(projectPermissions, 'idGroup')" :key="permission.id">
                      <ul v-if="permission.idGroup > 0">
                        <li>
                          <div class="notIcon mx-4 groupName" type="button" @click="getFilter(permission.idGroup)"
                               :style="{textDecoration: permission.idGroup == selectedGroupId ? 'underline' : '',
                                          textUnderlinePosition:permission.idGroup == selectedGroupId ? 'under' : ''}">
                              {{permission.groupName}}
                          </div>
                        </li>
                      </ul>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-9 col-md-9 mx-lg-2">
        <div class="row dashboard-border">
          <div class="col-md-4 col-12 align-self-center" >
            <img src="../../assets/icons/projects.png" height="32" width="32"/>
            <span class="mx-2"> Role Permissions</span>
          </div>
          <div class="col-md-8 col-12 text-end align-self-center">
            <button class="btn" type="button" style="background-color: #56759c;color:#ffffff;margin-right: 5px;" @click="openCloseGroupModal()" data-bs-toggle="modal" data-bs-target="#addGroup">
              <font-awesome-icon icon="plus"/>
              <span style="color: #ffffff;font-weight: unset" class="px-1">Add Group</span>
            </button>
            <button class="btn" type="button" style="background-color: #56759c;color:#ffffff;margin-right: 3px;" @click="openCloseRoleModal()" data-bs-toggle="modal" data-bs-target="#addRole">
              <font-awesome-icon icon="plus"/>
              <span style="color: #ffffff;font-weight: unset" class="px-1">Add Role</span>
            </button>
            <button class="btn" type="button" style="background-color: #d51317;color:#ffffff;margin-left: 5px;" @click="openCloseDeleteRoleModal()" data-bs-toggle="modal" data-bs-target="#deleteModal">
              <font-awesome-icon icon="plus"/>
              <span style="color: #ffffff;font-weight: unset" class="px-1">Delete Role</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row modified-table mt-3 table-responsive">
              <table class="table table-bordered table-font table-hover table-scroll" id="DynamicTable">
                <thead>
                <tr>
                  <th>Resource</th>
                  <th v-for="role in rolesOfProject" :key="role.id">
                    {{role.roleName}}
                  </th>
                </tr>
                </thead>
                <tbody style="vertical-align: middle">
                <tr style="width: 10%" v-for="permission in filterProjectPermissions" :key="permission.id">
                  <td style="width: 10%; font-weight: bold">{{permission.permissionName}}</td>
                  <td v-for="role in rolesOfProject" :key="role.id">
                       <span v-if="role.id>0">
                              <button class="button perm-button" style="width: 50px" title="" :class="CheckPermissionForRole(role.id,permission.id)"
                                      @click="SetPermissionForRole(role.id,permission.id)">
                                <font-awesome-icon :icon="CheckPermissionForRoleIcon(role.id,permission.id)" size="sm"/>
                              </button>
                       </span>
                  </td>
                </tr>
                </tbody>
              </table>
              <div class="col-12" v-if="projectPermissions.length < 1" style="text-align: center">
                <p style="font-size: 18px;">No results found!</p>
              </div>
            </div>
          </div>
        </div>
    </div>
    <add-group :projectId='selectedProjectId'
              :isActiveGroupModal='isActiveGroupModal'
              @openCloseGroupModal="openCloseGroupModal"
    />
    <add-role :projectId='selectedProjectId'
              :isActiveProjectRoleModal='isActiveProjectRoleModal'
              @openCloseRoleModal="openCloseRoleModal"
    />
    <delete-role :projectId='selectedProjectId'
                 :isActiveDeleteRoleModal='isActiveDeleteRoleModal'
                 @openCloseDeleteRoleModal="openCloseDeleteRoleModal"
    />
    <div class="col-md-2"></div>
  </div>
</template>
<script>

  import {loadingMixin} from "../../utils/mixins";
  import {mapActions, mapState} from "vuex";
  import AddGroup from "../../components/ui/AddGroup";
  import AddRole from "../../components/ui/AddRole";
  import DeleteRole from "../../components/ui/DeleteRole";


  export default {
    name: "RolePermissions",
    mixins: [loadingMixin],
    components: {
      AddGroup,
      AddRole,
      DeleteRole,
    },
    data() {
      return {
        selectedProjectId: 0,
        selectedGroupId:0,
        isActiveGroupModal: false,
        isActiveProjectRoleModal: false,
        isActiveDeleteRoleModal: false,
        searchText: "",
        setRolePermission: {
          roleId: 0,
          permissionId: 0,
          accessType: 'R'
        },
      }
    },

    methods: {
      ...mapActions('projects', ['getProjects', 'getProject', 'getUserProject', 'addUserProject', 'addProject', 'openCloseProjectModal', 'deleteUser']),
      ...mapActions('users', ['getUsers']),
      ...mapActions('roles', ['getRoles', 'getRolesOfProject', 'addRole', 'deleteRole', 'getPermissions', 'getRolePermissions', 'addRolePermission', 'getPermissionsByProject']),


       goToDetails(id,name, code) {
        this.selectedProjectId = id;
        this.selectedProjectName = name;
        this.selectedProjectCode = code;
        this.selectedGroupId = 'all';
        this.getRolesOfProject(this.selectedProjectId);
        this.getRolePermissions(this.selectedProjectCode);
        this.getPermissionsByProject(this.selectedProjectId);
      },
      returnDistinctList(array, key) {
        const arrayUniqueByKey = [...new Map(array.map(item =>
            [item[key], item])).values()];
        return arrayUniqueByKey;
      },
      getFilter(idGroup){
        this.selectedGroupId = idGroup;
      },
      async openCloseGroupModal() {
        this.isActiveGroupModal = !this.isActiveGroupModal;
      },
      async openCloseRoleModal() {
        this.isActiveProjectRoleModal = !this.isActiveProjectRoleModal;
      },
      async openCloseDeleteRoleModal() {
        this.isActiveDeleteRoleModal = !this.isActiveDeleteRoleModal;
      },
      async SetPermissionForRole(roleid, permid) {
        var result = this.rolePermissions.filter(x => x.roleId == roleid).filter(x => x.permissionId == permid)

        if (result.length > 0) {
          let accessType = result[0].accessType;
          if (accessType.trim() == 'R') {
            this.setRolePermission.accessType = 'W'
          } else {
            this.setRolePermission.accessType = 'N'
          }
        } else {
          this.setRolePermission.accessType = 'R';
        }

        this.setRolePermission.roleId = roleid;
        this.setRolePermission.permissionId = permid;

        try {
          await this.addRolePermission(this.setRolePermission);
          this.$notify({
            title: "Success",
            text: "Updated role permission successfully. ",
            type: "success"
          });
          await this.getRolePermissions(this.selectedProjectCode);
          await this.getPermissions()

        } catch (e) {
          this.$notify({
            title: "Error",
            text: "Failed to update role permission .." + e.message,
            type: "error"
          });
        }
      },
      CheckPermissionForRoleIcon(roleid, permid) {
        var result = this.rolePermissions.filter(x => x.roleId == roleid).filter(x => x.permissionId == permid)
        if (result.length > 0) {
          let accessType = result[0].accessType;
          if (accessType.trim() == "R") {
            return 'eye';
          } else {
            return 'edit';
          }
        } else {
          return 'times'
        }
      },
      CheckPermissionForRole(roleid, permid) {
        var result = this.rolePermissions.filter(x => x.roleId == roleid).filter(x => x.permissionId == permid)
        if (result.length > 0) {
          let accessType = result[0].accessType;
          if (accessType.trim() == "R") {
            return 'alert alert-warning';
          } else {
            return 'alert alert-success';
          }
        } else {
          return 'alert alert-danger'
        }
      },
    },

    computed: {
      ...mapState('projects', ['projects', 'project', 'userProject', 'isActiveProjectModal']),
      ...mapState('users', ['userList']),
      ...mapState('roles', ['roles', 'rolesOfProject', 'rolePermissions', 'permissions', 'projectPermissions']),

      userProjects: function () {
        return this.projects.filter((post) => {
          return post.projectName.toUpperCase().match(this.searchText.toUpperCase());
        });
      },
      filterProjectPermissions: function () {
            if(this.selectedGroupId == 'all'){
              return this.projectPermissions;
            }else{
              return this.projectPermissions.filter((post) => {
                return post.idGroup == this.selectedGroupId;
              });
            }
      },
    },
    async created() {
      this.showLoading();
      try {
        await this.getProjects();
      } finally {
        this.hideLoading();
      }
    },
  }
</script>

<style scoped>

  .accordion-item{
    margin-bottom: 5px;
  }
  .accordion-button{
    height: 40px;
  }
  .accordion-item:not(:first-of-type) {
    border: 1px solid #dee2e6;
  }
  .accordion-button:focus {
    box-shadow: unset;
  }
  .accordion-button:not(.collapsed)::before {
    background-image: var(--bs-accordion-btn-active-icon);
    transform: rotate(-180deg);;
  }
  .accordion-button:not(.collapsed){
    background-color: unset;
    color: #56759c;
    box-shadow: inset 0 calc(-1 * 1px) 0 #dee2e6;
  }
  .accordion-button::before {
    flex-shrink: 0;
    width: 1.25rem;
    height: 1.25rem;
    content: "";
    background-image: var(--bs-accordion-btn-icon);
    background-repeat: no-repeat;
    background-size: 1.25rem;
    transition: transform 0.2s ease-in-out;
  }
  .accordion-button::after {
    display: none;
  }
  .notIcon::before{
    display: none;
  }
  .groupName:hover{
    text-decoration: underline;
    text-underline-position: under;
  }

  .private-project-border{
    padding:12px;
    box-shadow: 0px 3px 10px #ced4da;
    cursor: pointer;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
   ul li {
    font-size: 14px;
  }
  .perm-button:hover {
    box-shadow: rgba(3, 102, 214, 0.3) 0px 0px 0px 3px;
  }
  .perm-button{
    width: 35px !important;
    height: 30px;
    padding: 0px;
  }
  .form-control:focus {
    border-color: #56759c;
    box-shadow: 0 0 0 0.10rem #15458d40;
  }
</style>
